"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getRegisteredFields;
function getRegisteredFields(formName) {
    return function (state) {
        return state.form[formName].registeredFields;
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZm9ybS9nZXRSZWdpc3RlcmVkRmllbGRzLmpzeCJdLCJuYW1lcyI6WyJnZXRSZWdpc3RlcmVkRmllbGRzIiwiZm9ybU5hbWUiLCJzdGF0ZSIsImZvcm0iLCJyZWdpc3RlcmVkRmllbGRzIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFBd0JBLG1CO0FBQVQsU0FBU0EsbUJBQVQsQ0FBNkJDLFFBQTdCLEVBQXVDO0FBQ2xELFdBQU8sVUFBQ0MsS0FBRCxFQUFXO0FBQ2QsZUFBT0EsTUFBTUMsSUFBTixDQUFXRixRQUFYLEVBQXFCRyxnQkFBNUI7QUFDSCxLQUZEO0FBR0giLCJmaWxlIjoiZ2V0UmVnaXN0ZXJlZEZpZWxkcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGdldFJlZ2lzdGVyZWRGaWVsZHMoZm9ybU5hbWUpIHtcbiAgICByZXR1cm4gKHN0YXRlKSA9PiB7XG4gICAgICAgIHJldHVybiBzdGF0ZS5mb3JtW2Zvcm1OYW1lXS5yZWdpc3RlcmVkRmllbGRzXG4gICAgfVxufVxuIl19